/**
 * Where the landing page sends people. The app lives on its own origin; in development it is the local app on 7040.
 * Set `VITE_APP_URL` to point a build somewhere else.
 */
export const APP_URL: string = import.meta.env.VITE_APP_URL ?? (import.meta.env.DEV ? "http://localhost:7040" : "https://app.modelcurve.com");

export const SIGN_UP_URL = `${APP_URL}/signup`;
export const SIGN_IN_URL = `${APP_URL}/signin`;
/** The MCP server's address, for "Add a custom connector" in Claude. */
export const MCP_URL = `${APP_URL}/mcp`;
